const initialPopupState = {
    DATA_LIST : null,

    TIP_SHOW : false,

    NOW_STEP : 1,
    BOX_SHOW : false,
    SUCCESS_HANDLE : null
};

export default function ( state = initialPopupState, action = {} ){
    switch( action.type ){
        case "POPUP_LIMITION_BUY_DATA":
            return Object.assign({},state,{
                DATA_LIST : action.DATA_LIST
            });

        case "POPUP_LIMITION_BUY_SHOW":
            return Object.assign({},state,{
                NOW_STEP : action.NOW_STEP,
                BOX_SHOW : action.BOX_SHOW,
                SUCCESS_HANDLE : action.SUCCESS_HANDLE,
            });

        case "POPUP_LIMITION_BUY_TIP_SHOW":
            return Object.assign({},state,{
                TIP_SHOW : action.TIP_SHOW,
            });

        default:
            return state  
    }
}


// WEBPACK FOOTER //
// ./common/reducers/popup_DeleteList.js